var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10.6667,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1646,
    y: 11.1646,
    width: 6.74683,
    height: 6.74683,
    rx: 2.24894,
    stroke: "black",
    strokeWidth: 1.68671
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1646,
    y: 22.4092,
    width: 6.74683,
    height: 6.74683,
    rx: 2.24894,
    stroke: "black",
    strokeWidth: 1.68671
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4092,
    y: 11.1646,
    width: 6.74683,
    height: 6.74683,
    rx: 2.24894,
    stroke: "black",
    strokeWidth: 1.68671
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4092,
    y: 22.4092,
    width: 6.74683,
    height: 6.74683,
    rx: 2.24894,
    stroke: "black",
    strokeWidth: 1.68671
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a98f5236be4c5ac0e0cfba7d1071551c.svg";
export { ForwardRef as ReactComponent };